import { EditButton } from './EditButton';

export default EditButton;
